import { render, staticRenderFns } from "./ResourceTags.vue?vue&type=template&id=5cfac6e2"
import script from "./ResourceTags.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResourceTags.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports